import React from "react";
import { actions } from "primarycare-binder";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import CardActions from "@material-ui/core/CardActions";
import Collapse from "@material-ui/core/Collapse";
import Card from "@material-ui/core/Card";
import IconButton from "@material-ui/core/IconButton";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { withStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { Div, Row, Text, Divider, TapSelect } from "qdm-component-library";
import BillSummary from "../../assets/img/bill_summary.svg";
import { UIColor } from "../../utils";
const styles = (theme) => ({
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    padding:16,
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
  body: {
    paddingTop: 0,
    paddingLeft: 16,
    paddingRight: 16,
    paddingBottom: 16,
  },
  TapSelect: {
    "& div": {
      "& span": {
        fontSize: 12,
        fontFamily: "pc_medium !important",
      },
    },
  },
});

class DoctorAndAppointmentSlot extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: true,
    };
  }

  handleExpandClick = () => {
    this.setState({
      expanded: !this.state.expanded,
    });
  };

  componentDidMount() { }

  shouldComponentUpdate(props, state) {
    return true;
  }

  render() {
    const { classes, parent_id } = this.props;
    return (
      <Card
        id={`${parent_id}_billsummary_parent_card`}
        style={{
          boxShadow: "none",
          border: "1.5px solid #E0E0E0",
          borderRadius: 8,
        }}
      >
        <CardActions
          id={`${parent_id}_billsummary_cardactions`}
          onClick={this.handleExpandClick}
          disableSpacing
          style={{
            padding: 0,
            paddingLeft: 16,
            paddingBottom: 0,
            cursor: "pointer",
          }}
        >
          <img
            id={`${parent_id}_billsummary_cardactions_img`}
            alt="BillSummary"
            src={BillSummary}
            style={{ marginRight: 12 }}
          />
          <Text
            id={`${parent_id}_billsummary_cardactions_text`}
            key={"0"}
            name="Bill Summary"
            style={{ fontSize: "16px", color: UIColor.primaryText.color,letterSpacing:0 }}
            className={"pc_semibold"}
          />

          <IconButton
            id={`${parent_id}_billsummary_iconbutton`}
            className={clsx(classes.expand, {
              [classes.expandOpen]: this.state.expanded,
            })}
            aria-expanded={this.state.expanded}
            aria-label="show more"
          >
            <ExpandMoreIcon
              id={`${parent_id}_billsummary_expandmoreIcon`}
            />
          </IconButton>
        </CardActions>
        <Collapse
          id={`${parent_id}_billsummary_collapse`}
          className={classes.body}
          in={this.state.expanded}
          timeout="auto"
          unmountOnExit
        >
          <Div
            key={"0"}
            className="qdm"
            id={`${parent_id}_billsummary_billing_details_div`}
            style={{
              backgroundColor: UIColor.differentiationBackground.color,
              borderColor: UIColor.lineBorderFill.color,
              borderWidth: "1.5px",
              borderRadius: "8px",
              padding: "16px",
            }}
          >
            <Row
              id={`${parent_id}_billsummary_billing_details_row`}
              key={"0"}
              alignItems="normal"
              direction="row"
              justify="space-between"
              spacing="2"
            >
              <Text
                id={`${parent_id}_billsummary_billing_details_text`}
                key={"0"}
                name="Billing Detail"
                style={{
                  textTransform: "uppercase",
                  color: "#6F6F6F",
                  fontSize: "12px",
                  letterSpacing: "0px",
                }}
                className={"pc_medium"}
              />

              <Text
                id={`${parent_id}_billsummary_billing_details_price_text`}
                key={"1"}
                name="Price"
                style={{
                  color: "#6F6F6F",
                  textTransform: "uppercase",
                  fontSize: "12px",
                  letterSpacing: "0px",
                }}
                className={"pc_medium"}
              />
            </Row>

            <Row
              id={`${parent_id}_billsummary_billing_total_row`}
              key={"1"}
              alignItems="stretch"
              direction="row"
              justify="space-between"
              spacing="0"
            >
              <Divider
                id={`${parent_id}_billsummary_billing_total_divider`}
                key={"0"}
                textWidth="50"
                textColor="#000"
                borderColor="lightgray"
                borderWidth="1"
                orientation="horizontal"
                variant="middle"
                style={{ padding: "0px", margin:'8px 0px' }}
              />

              <Row
                id={`${parent_id}_billsummary_billing_total_sub_row`}
                key={"1"}
                alignItems="normal"
                direction="row"
                justify="space-between"
                spacing="2"
                style={{ width: "100%" }}
              >
                <Text
                  id={`${parent_id}_billsummary_billing_total_text`}
                  key={"0"}
                  name="Total Charges"
                  style={{ letterSpacing:0, fontSize: "14px" }}
                  className={"pc_medium"}
                />

                <Text
                  id={`${parent_id}_billsummary_billing_total_data_text`}
                  key={"1"}
                  name="₹780.00"
                  style={{ letterSpacing:0, fontSize: "14px" }}
                  className={"pc_medium"}
                />
              </Row>
            </Row>
          </Div>

          <Row
            id={`${parent_id}_billsummary_billing_addinsurance_row`}
            key={"1"}
            alignItems="stretch"
            direction="row"
            justify="space-between"
            spacing="2"
            style={{
              padding:'12px 0px 16px'
            }}
          >
            <Div key={"0"}
              id={`${parent_id}_billsummary_billing_addinsurance_div`}
            >
              <Text
                id={`${parent_id}_billsummary_billing_addinsurance_text`}
                key={"0"}
                name="+ Add Insurance"
                style={{
                  color: "#38C20A",
                  fontSize: "14px",
                  letterSpacing:0
                }}
                className={"pc_medium"}
              />
            </Div>

            <Div key={"1"}
              id={`${parent_id}_billsummary_billing_addinsurance_viewsplitup_div`}
            >
              <Text
                id={`${parent_id}_billsummary_billing_addinsurance_viewsplitup_text`}
                key={"0"}
                name="View Split Up"
                style={{
                  color: UIColor.secondaryButtonColor.color,
                  fontSize: "14px",
                  marginRight: "",
                  letterSpacing:0
                }}
                className={"pc_medium"}
              />
            </Div>
          </Row>

          <Div
            id={`${parent_id}_billsummary_billing_paymentmode_div`}
            key={"2"}
            className="qdm"
            style={{ padding: "0px", margin: "0px", marginBottom: "0" }}
          >
            <Divider
              id={`${parent_id}_billsummary_billing_paymentmode_divider`}
              key={"0"}
              textWidth="100"
              textColor="#000"
              borderColor="lightgray"
              borderWidth="1"
              orientation="horizontal"
              variant="fullWidth"
              style={{ padding: "0px",margin:0,marginBottom:16 }}
              className={classes.hrtag}
            />

            <Div key={"1"}
              id={`${parent_id}_billsummary_billing_paymentmode_sub_div`}
            >
              <Text
                id={`${parent_id}_billsummary_billing_paymentmode_text`}
                key={"0"}
                name="Payment Mode"
                style={{ fontSize: "14px", letterSpacing:0 }}
                className={"pc_regular"}
              />
            </Div>

            <TapSelect
              id={`${parent_id}_billsummary_billing_paymentmode_tapselet_`}
              key={"1"}
              label=""
              type="single"
              fullWidth={true}
              sselectedBorderColor={UIColor.secondaryButtonColor.color} 
              selectedBackgroundColor={UIColor.secondaryButtonColor.color}
              selectedTextColor="#fff"
              borderColor={UIColor.differentiationBackground.color}
              backgroundColor={UIColor.differentiationBackground.color}
              textSize="medium"
              iconHeight="20"
              iconWidth="20"
              textColor={UIColor.primaryText.color}
              options={[
                {
                  label: "Pay Later",
                  value: "pay_later",
                },
                {
                  label: "Pay Now",
                  value: "pay_now",
                },
              ]}
              inLineStyles={{
                // color: UIColor.primaryText.color,
                padding: "6px",
                borderRadius: 12,
                margin:'8px 8px 0px 0px'
              }}
              onChange={(val) => {
                this.props.changeState("paymentOption", val);
              }}
              defaultSelected={this.props.paymentOption}
              className={classes.TapSelect}
            />
          </Div>
        </Collapse>
      </Card>
    );
  }
}

const mapStateToProps = (state) => ({});

export default withStyles(styles)(
  connect(mapStateToProps, actions)(withRouter(DoctorAndAppointmentSlot))
);
